import type { DocNode } from '@atlaskit/adf-schema/doc';
import { StoreActionLoggableName } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { addStoreChatItem } from './addStoreChatItem';
import { createSafeAction, type SafeAction } from './createSafeAction';
import { createStoreAssistant } from './createStoreAssistant';
import type { ChatStoreAction } from './types';

type AddAssistantMessageArgs = {
	id: string;
	content: string | DocNode;
	conversationId?: string;
	agentNamedId?: string;
	agentAuthorId?: string;
	agentAuthorIdentityAccountId?: string;
	entryPoint?: string;
	actionId?: string;
	isMultiSiteQuery?: boolean;
};

export const addAssistantMessage: SafeAction<[AddAssistantMessageArgs]> = createSafeAction(
	StoreActionLoggableName.addAssistantMessage,
	({
		id,
		content,
		conversationId: conversationIdParam,
		agentNamedId,
		agentAuthorId,
		agentAuthorIdentityAccountId,
		entryPoint,
		actionId,
		isMultiSiteQuery,
	}: AddAssistantMessageArgs): ChatStoreAction =>
		({ getState, dispatch }) => {
			const conversationId = conversationIdParam ?? getState().currentConversationId;
			const assistantMessageParams = {
				id,
				content,
				agentNamedId,
				agentAuthorId,
				agentAuthorIdentityAccountId,
				...(entryPoint ? { entryPoint } : {}),
				...(actionId ? { actionId } : {}),
				isMultiSiteQuery,
				conversationId,
			};

			dispatch(
				addStoreChatItem({
					message: createStoreAssistant(assistantMessageParams),
					conversationId,
				}),
			);
		},
);
